module.exports = __webpack_public_path__ + "static/media/Closed Captions Test_1633892700615.980c4245.vtt";